module.exports = __webpack_public_path__ + "img/discount.f9bd814b.svg";